export class Insurance {

    constructor() {
    }

    authorityTypeId: string;
    id: number;
    carrierId: number;
    insuranceTypeId: number;
    name: string;
    rating: string;
    expiration: Date;
    amount: number;
    umbrellaAmount: number;
    endorsements: Array<any>;
    type: string;
    tempUpdate: boolean;
    riskPool: boolean;
    isCanceled: boolean;
}
